import type { ReactNode } from 'react';
import { AppConfigContext } from './app-config-context';
import type { WebAppConfig } from '../model/types';

export function AppConfigProvider({
  config,
  children,
}: {
  config: WebAppConfig;
  children: ReactNode;
}) {
  return (
    <AppConfigContext.Provider value={config}>
      {children}
    </AppConfigContext.Provider>
  );
}
